import { Alert, Typography } from 'antd';

import { LONG_WAIT_WARNING } from '@pages/Integrations/IntegrationsList/components/ConnectIntegrationModal/constants';

import type { FC } from 'react';

const { Text } = Typography;

export interface LongWaitNoticeProps {
  /** Текущая подсказка из набора шага; null — пока ожидание не затянулось */
  hint: string | null;
}

/**
 * Объяснение затянувшегося ожидания (task/10903): предупреждение не закрывать
 * окно и сменяющаяся подсказка. Индикатор самого процесса уже рисует
 * конкретный экран: QR использует циклический progress, остальные шаги —
 * skeleton/spinner, поэтому второй прогресс здесь только создавал бы шум.
 */
export const LongWaitNotice: FC<LongWaitNoticeProps> = ({ hint }) => (
  <div
    className="connect-integration-modal__long-wait"
    data-testid="connect-auth-long-wait"
  >
    <Alert type="info" showIcon message={LONG_WAIT_WARNING} />
    {hint ? <Text type="secondary">{hint}</Text> : null}
  </div>
);
